import React from 'react';
import PropTypes from 'prop-types';
import PlayerLineupInfo from '~/components/PlayerLineupInfo/PlayerLineupInfo';
import StyledComponent from '~/components/Styled/Styled';
import groupBy from 'lodash/groupBy';
import get from 'lodash/get';

import { defineMessages, injectIntl, intlShape } from 'react-intl';
import css from '~/components/PlayerLineup/PlayerLineup.scss';

const getTeamName = lineupInfo => get(lineupInfo, 'team.medium_name', '');

const renderPlayers = lineupInfos => {
  if (!lineupInfos) return null;

  return (
    <div className={css.players}>
      {lineupInfos.map(lineupInfo => {
        const stats = {
          play_status: lineupInfo.play_status,
          has_yellow_card: lineupInfo.has_yellow_card,
          has_red_card: lineupInfo.has_red_card,
          substituted_at: lineupInfo.substituted_at,
          substituted_for: lineupInfo.substituted_for,
          goals: lineupInfo.goals,
        };

        return <PlayerLineupInfo player={lineupInfo.player} key={lineupInfo.id} stats={stats} />;
      })}
    </div>
  );
};

const messages = defineMessages({
  lineup: {
    id: 'player_lineup.lineup',
    defaultMessage: 'Lineup',
  },
  substitutions: {
    id: 'game_detials.substitutions',
    defaultMessage: 'Substitutions',
  },
});

class PlayerLineup extends React.PureComponent {
  render() {
    const startingLineupByTeam = groupBy(
      this.props.lineup.filter(player => player.play_status === 'Starter'),
      getTeamName
    );

    const benchedLineupByTeam = groupBy(
      this.props.lineup.filter(player => player.play_status === 'Benched'),
      getTeamName
    );

    const { intl: { formatMessage } } = this.props;

    return (
      <div className={css.container}>
        {Object.keys(startingLineupByTeam).map(teamName => (
          <div className={`col-sm-6 ${css.column}`} key={teamName}>
            <div className={css.title}>{`${formatMessage(messages.lineup)} - ${teamName}`}</div>
            {renderPlayers(startingLineupByTeam[teamName])}
            <div className={css.subTitle}>{formatMessage(messages.substitutions)}</div>
            {renderPlayers(benchedLineupByTeam[teamName])}
          </div>
        ))}
      </div>
    );
  }
}

PlayerLineup.propTypes = {
  lineup: PropTypes.arrayOf(
    PropTypes.shape({
      alignment: PropTypes.string.isRequired,
      team: PropTypes.shape({
        medium_name: PropTypes.string.isRequired,
      }).isRequired,
      player: PropTypes.shape({
        first_initial_and_last_name: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  intl: intlShape.isRequired,
};

PlayerLineup.displayName = 'PlayerLineup';

export default injectIntl(StyledComponent(PlayerLineup, [css]));
